const calculateLineHeight = (ratio, fontSize) => {
  const lineHeight = Math.floor(fontSize * ratio);
  return lineHeight;
};

export const getLineHeight = (ratio) => {
  return (fontSize) => {
    return calculateLineHeight(ratio, fontSize);
  };
};
